/**
 * useOrgReviewCount (GDN-2271)
 *
 * Lightweight count of pending org-review items. Drives both the count-gated
 * practice tab and the page-level empty-state gating. Uses `per_page: 1` (we
 * only need `total`) plus a polling interval so the tab count stays fresh while
 * a practice admin works, and skips entirely for users without the
 * `manage_organization` permission so the provider endpoint is never called for
 * non-administrators.
 */

import { useCan } from '@features/user';

import { useListOrgReviewItemsQuery } from '../store/hooks';

const POLL_INTERVAL_MS = 30_000;

export function useOrgReviewCount(): number {
  const canManageOrganization = useCan('manage_organization');
  const { data } = useListOrgReviewItemsQuery(
    { perPage: 1 },
    {
      skip: !canManageOrganization,
      pollingInterval: POLL_INTERVAL_MS,
    },
  );
  return data?.total ?? 0;
}
